import { h } from 'preact';
import { Text } from 'preact-i18n';
import cx from 'classnames';
import { trackProps, DIMENSION } from '@cube/track';
import { appendTrackingParameters } from '../../lib/helpers';
import style from './style';
import WeatherSVGIcon from '../weather-svg-icon/';

/**
 * Render the full Current Weather component
 * @param  {Object}   today         	Current weather information
 * @param  {Object}   airQuality    	Air quality information
 * @param  {boolean}  isCelsius     	True if 'C' or false if 'F'
 * @param  {Object}   trackingParams	Configuration for utm_* url parameters
 * @return {string}                 	The rendered component
 */
const CurrentFull = ({ today, airQuality, isCelsius, trackingParams, showAlert }, context) => {

	const currentTemp = (isCelsius) ? today.currentTempCels : today.currentTemp;

	const airQualityLink = appendTrackingParameters(airQuality.link, trackingParams);

	return (
		<div class={cx(style.current, style.full, (showAlert && style.showAlert))}>
			<div class={style.fullContainer}>
				
				<div class={style.tempAndConditionIcon}>
					<div class={style.icon}>
						<WeatherSVGIcon
							name={today.weatherIconCode}
							class={style.conditionIcon}
							width={120}
							height={120}
						/>
					</div>
					<div class={style.temperature}>
						<div class={style.temp}>{currentTemp}&deg;</div>
					</div>
				</div>
				<div class={style.conditionBox}>
					<div class={style.description}>{today.conditionDescription}</div>
					<a
						class={style.airQuality}
						href={airQualityLink}
						target="_blank"
						rel="noopener noreferrer"
						{...trackProps(
							{
								[DIMENSION.componentpath]: 'AirQuality'
							},
							context
						)}
					>
						<div class={style.airQualityDescription}>
							<span>{airQuality.category}</span> <span class={style.airQualityText}><Text id="airQuality" /></span>
						</div>
					</a>
				</div>
			</div>
		</div>
	);
};
export default CurrentFull;
